import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Select, Input, Button, message, Spin, Empty } from 'antd';
import Header from "../../components/Header"
import Footer from '../../components/Footer';
import api from '../../services/api';
import './styles.css';
import 'antd/dist/antd.css';
import { saveAs } from 'file-saver';
import { paises } from '../../assets/paises';
import moment from 'moment';
import { municipioService } from '../../services/Municipios-Service/municipios-service';
import { loginService } from '../../services/Login-Service/login-service';

interface RelatorioProps {
    permissao?: any
    modalStatus?: any,
    setNovoFeriadoModal?: any,
    setEditarFeriadoModal?: any
}

interface Orgao {
    orgaoID: any,
    nome: String,
    sigla: String,
    ativo: Boolean
}

interface Servico {
    servicoID: any,
    descricao: String,
    ativo: Boolean
}

interface Vinculo {
    vinculoOrgaoServicoID: any,
    orgaoID: Number,
    servicoID: Number,
    ativo: Boolean,
    orgao: {
        orgaoID: Number,
        nome: String,
        sigla: String,
        ativo: Boolean
    },
    servico: {
        servicoID: any,
        descricao: String,
        ativo: Boolean
    }
}

const Relatorio: React.FC<RelatorioProps> = (prop) => {
    const [formRelatorioAtendimentoMesAno] = Form.useForm();
    const [formRelatorioGeneroMesAno] = Form.useForm();
    const [formNacionalidade] = Form.useForm();
    const [formComparacao] = Form.useForm();
    const [formServicoOfertado] = Form.useForm();
    const [formMigrantesNacionalidadeMes] = Form.useForm();
    const [formServicoOfertadoOrgao] = Form.useForm();
    const [municipios, setMunicipios] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [orgaos, setOrgaos] = useState<Array<Orgao>>([]);
    const [servicos, setServicos] = useState<Array<Servico>>([]);
    const [vinculos, setVinculos] = useState<Vinculo[]>([]);
    const [outro, setOutro] = useState<boolean>(true);
    const [selecionouOrgao, setSelecionouOrgao] = useState<boolean>(false);

    const meses = [
        { id: 0, descricao: 'Todos' },
        { id: 1, descricao: 'Janeiro' },
        { id: 2, descricao: 'Fevereiro' },
        { id: 3, descricao: 'Março' },
        { id: 4, descricao: 'Abril' },
        { id: 5, descricao: 'Maio' },
        { id: 6, descricao: 'Junho' },
        { id: 7, descricao: 'Julho' },
        { id: 8, descricao: 'Agosto' },
        { id: 9, descricao: 'Setembro' },
        { id: 10, descricao: 'Outubro' },
        { id: 11, descricao: 'Novembro' },
        { id: 12, descricao: 'Dezembro' },
    ]
    const anoAtual = new Date().getFullYear();

    useEffect(() => {
        getOrgaos();
        getServicos();
        getMunicipios();
    }, [])

    async function getOrgaos() {
        await api.get("Orgao/getall").then(response => {
            setOrgaos(response.data);
        });
    }

    async function getServicos() {
        await api.get("Servico/getall").then(response => {
            setServicos(response.data);
        });
    }

    async function getMunicipios() {
        await municipioService.getMunicipio().then((resp)=>{
            if (loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "")){
                setMunicipios(resp.data)
            }
            else{
                let municipiosAux = resp.data;
                const newOption = { municipioID: 0, nome: 'Todos', codigoIBGE: null, uf: null };
                municipiosAux.unshift(newOption);
                setMunicipios(municipiosAux);
            }
        })
    }

    async function getVinculoOrgaoServico(orgaoId: any) {
        if (orgaoId != null) {
            await api.post("VinculoOrgaoServico/getcomfiltros",
                { orgaoID: orgaoId })
                .then((response: any) => {
                    setVinculos(response.data)
                });
            setSelecionouOrgao(true);
        }
        else {
            setSelecionouOrgao(false);
        }
        formServicoOfertadoOrgao.setFieldsValue({ servico: null });
    }

    const RelatorioAtendimentoMesAno = async (values: any) => {

        await api.get(`Relatorio/getQuantitativoAtendimentoMesAno?mes=${values.RelatorioAtendimentoMes}&ano=${values.RelatorioAtendimentoAno}&cidade=${values.RelatorioAtendimentoCidade}`, { responseType: 'arraybuffer' }).then((res) => {
            if (res.data?.valido === false) {
                message.error(res.data?.error);
            }
            else {
                saveAs(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Relatorio de Atendimento - ${values.RelatorioAtendimentoAno}.xlsx`);
            }

        }).catch(err => message.error(err))

    }

    const RelatorioAtendimentoNacionalidade = async (values: any) => {

        await api.get(`Relatorio/getQuantitativoAtendimentoNacionalidade?mes=${values.mes}&ano=${values.ano}&nacionalidade=${values.nacionalidade}&cidade=${values.RelatorioNacionalidadeCidade}`, { responseType: 'arraybuffer' }).then((res) => {
            if (res.data?.valido === false) {
                message.error(res.data?.error);
            }
            else {
                saveAs(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Relatorio de Atendimento Nacionalidade - ${values.ano}.xlsx`);
            }

        }).catch(err => message.error("Nenhum Registro Encontrado"))

    }

    const RelatorioMigranteNacionalidade = async (values: any) => {
        await api.get(`Relatorio/getQuantitativoMigranteNacionalidade?mes=${values.mes}&ano=${values.ano}&nacionalidade=${values.nacionalidade}&cidade=${values.RelatorioMigranteCidade}`, { responseType: 'arraybuffer' }).then((res) => {
            if (res.data?.valido === false) {
                message.error(res.data?.error);
            }
            else {
                saveAs(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Relatorio de Migrante Nacionalidade - ${values.ano}.xlsx`);
            }

        }).catch(err => message.error("Nenhum Registro Encontrado"))

    }

    const RelatorioGeneroMesAno = async (values: any) => {
        setLoading(true)
        await api.get(`Relatorio/getQuantitativoGeneroMesAno?mes=${values.RelatorioGeneroMes}&ano=${values.RelatorioGeneroAno}&cidade=${values.RelatorioGeneroCidade}`, { responseType: 'arraybuffer' }).then((res) => {
            saveAs(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Relatorio Gênero - ${values.RelatorioGeneroAno}.xlsx`);
        }).catch(err => message.error(err))
            .finally(() => {
                setLoading(false)
            })

    }

    const RelatorioComparacao = async (values: any) => {
        setLoading(true)
        await api.get(`Relatorio/getQuantitativoAgendadosAtendidosCancelados?mes=${values.dataRelatorioMes}&ano=${values.dataRelatorioAno}&cidade=${values.RelatorioComparacaoCidade}`, { responseType: 'arraybuffer' }).then((res) => {
            saveAs(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Relatorio de Agendados Atendidos Cancelados - ${values.dataRelatorioAno}.xlsx`);
        }).catch(err => message.error(err))
            .finally(() => {
                setLoading(false)
            })

    }

    // const RelatorioServicoOfertado = async (values: any) => {

    //     await api.get(`Relatorio/getQuantitativoServicoOfertado?mes=${values.mes}&ano=${values.ano}`, { responseType: 'arraybuffer' }).then((res) => {
    //         if (res.data?.valido === false) {
    //             message.error(res.data?.error);
    //         }
    //         else {
    //             saveAs(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Relatorio de Servico Ofertado - ${values.ano}.xlsx`);
    //         }

    //     }).catch(err => message.error("Nenhum Registro Encontrado"))
    // }

    const RelatorioServicoOfertadoOrgao = async (values: any) => {
        var orgaoID = values.orgao && !values.servico ? values.orgao : 0;
        var servicoID = values.servico && !selecionouOrgao ? values.servico : 0;
        var vinculoID = values.orgao && values.servico ? values.servico : 0;
        await api.get(`Relatorio/getQuantitativoServicoOfertadoOrgao?mes=${values.mes}&ano=${values.ano}&orgaoID=${orgaoID}&servicoID=${servicoID}&vinculoOrgaoServicoID=${vinculoID}`, { responseType: 'arraybuffer' }).then((res) => {
            if (res.data?.valido === false) {
                message.error(res.data?.error);
            }
            else {
                saveAs(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Relatorio de Servico Ofertado - ${values.ano}.xlsx`);
            }

        }).catch(err => message.error("Nenhum Registro Encontrado"))
    }

    return (
        <div>
            <Header></Header>
            <br />
            <div className="container">
                <fieldset className="fieldset-consulta borda-fieldset-atendimentos">
                    <legend className="custom-legend">Quantitativo de Atendimentos Por Mês, Ano e Cidade</legend>
                    <Form
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                        layout="horizontal"
                        form={formRelatorioAtendimentoMesAno}
                        onFinish={RelatorioAtendimentoMesAno}
                        size="middle" >
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="Mês"
                                    name="RelatorioAtendimentoMes"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma data!',
                                        }
                                    ]}
                                    initialValue={0}
                                >
                                    <Select
                                        placeholder="selecione"
                                    >
                                        {meses.map((item, index) =>
                                            <Select.Option key={index} value={item.id}>{item.descricao}</Select.Option>)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="Municipio"
                                    name="RelatorioAtendimentoCidade"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma cidade!',
                                        }
                                    ]}
                                >
                                    <Select filterOption={(input: any, option: any) => {
                                        return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }}
                                    showSearch
                                    placeholder="Selecione um município"
                                    >
                                    {loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "") ? 
                                    <>
                                    <Select.Option 
                                     value={municipios?.municipioID}>{municipios?.nome}</Select.Option>
                                    </>                                    
                                    :
                                    <>
                                    {municipios?.map((value:any, index:number)=>
                                        <Select.Option key={index} value={value.municipioID}>{value.nome}</Select.Option>
                                        )}
                                    </>
                                    }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="Ano"
                                    name="RelatorioAtendimentoAno"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma data!',
                                        }
                                    ]}
                                    initialValue={anoAtual}
                                >
                                    <Input placeholder="informe o ano" />
                                </Form.Item>
                                <Spin spinning={loading}>
                                    <Button className="button-filtrar" type="primary" htmlType="submit">
                                        Emitir Relatório
                                    </Button>
                                </Spin>
                            </Col>
                        </Row>
                    </Form>

                </fieldset>
                <br />
                <fieldset className="fieldset-consulta borda-fieldset-genero">
                    <legend className="custom-legend">Quantitativo de Atendimentos de Gênero por Mês, Ano e Cidade</legend>
                    <Form
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                        layout="horizontal"
                        form={formRelatorioGeneroMesAno}
                        onFinish={RelatorioGeneroMesAno}
                        size="middle" >
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="Mês"
                                    name="RelatorioGeneroMes"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma data!',
                                        }
                                    ]}
                                    initialValue={0}
                                >
                                    <Select
                                        placeholder="selecione"
                                    >
                                        {meses.map((item, index) =>
                                            <Select.Option key={index} value={item.id}>{item.descricao}</Select.Option>)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="Municipio"
                                    name="RelatorioGeneroCidade"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma cidade!',
                                        }
                                    ]}
                                >
                                    <Select filterOption={(input: any, option: any) => {
                                        return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }}
                                    showSearch
                                        placeholder="Selecione um município"
                                    >
                                    {loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "") ? 
                                    <>
                                    <Select.Option  value={municipios?.municipioID}>{municipios?.nome}</Select.Option>
                                    </>                                    
                                    :
                                    <>
                                    {municipios?.map((value:any, index:number)=>
                                        <Select.Option key={index} value={value.municipioID}>{value.nome}</Select.Option>
                                        )}
                                    </>
                                    }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="Ano"
                                    name="RelatorioGeneroAno"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma data!',
                                        }
                                    ]}
                                    initialValue={anoAtual}
                                >
                                    <Input placeholder="informe o ano" />
                                </Form.Item>
                                <Spin spinning={loading}>
                                    <Button className="button-filtrar button-genero" type="primary" htmlType="submit">
                                        Emitir Relatório
                                    </Button>
                                </Spin>
                            </Col>
                        </Row>
                    </Form>

                </fieldset>
                <br />
                <fieldset className="fieldset-consulta borda-fieldset-atendidos-cancelados">
                    <legend className="custom-legend">Comparação entre Agendados, Atendidos e Cancelados</legend>
                    <Form
                        form={formComparacao}
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                        layout="horizontal"
                        onFinish={RelatorioComparacao}
                        size="middle" >
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="Mês"
                                    name="dataRelatorioMes"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma data!',
                                        }
                                    ]}
                                    initialValue={0}
                                >
                                    <Select
                                        placeholder="selecione"
                                    >
                                        {meses.map((item, index) =>
                                            <Select.Option key={index} value={item.id}>{item.descricao}</Select.Option>)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="Municipio"
                                    name="RelatorioComparacaoCidade"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma cidade!',
                                        }
                                    ]}
                                >
                                    <Select filterOption={(input: any, option: any) => {
                                        return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }}
                                    showSearch
                                    placeholder="Selecione um município"
                                    >
                                    {loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "") ? 
                                    <>
                                    <Select.Option  value={municipios?.municipioID}>{municipios?.nome}</Select.Option>
                                    </>                                    
                                    :
                                    <>
                                    {municipios?.map((value:any, index:number)=>
                                        <Select.Option key={index} value={value.municipioID}>{value.nome}</Select.Option>
                                        )}
                                    </>
                                    }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="Ano"
                                    name="dataRelatorioAno"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma data!',
                                        }
                                    ]}
                                    initialValue={anoAtual}
                                >
                                    <Input placeholder="informe o ano" />
                                </Form.Item>
                                <Spin spinning={loading}>
                                    <Button className="button-filtrar button-agendados-cancelados-atendidos" type="primary" htmlType="submit">
                                        Emitir Relatório
                                    </Button>
                                </Spin>
                            </Col>
                        </Row>
                    </Form>
                </fieldset>
                <br />
                <fieldset className="fieldset-consulta borda-fieldset-nacionalidade">
                    <legend className="custom-legend">Quantitativo de Atendimentos por Nacionalidade, Cidade, Mês e Ano</legend>
                    <Form
                        form={formNacionalidade}
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                        layout="horizontal"
                        onFinish={RelatorioAtendimentoNacionalidade}
                        size="middle" >
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col className="gutter-row" span={8}>
                                <Form.Item name="nacionalidade" label="Nacionalidade" initialValue="">
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione um país de Nacionalidade"
                                    >
                                        <Select.Option value="">Todas</Select.Option>
                                        {paises.map((p, index) => <Select.Option key={index} value={p}>{p}</Select.Option>)}

                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={8}>
                                <Form.Item
                                    label="Municipio"
                                    name="RelatorioNacionalidadeCidade"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma cidade!',
                                        }
                                    ]}
                                >
                                    <Select filterOption={(input: any, option: any) => {
                                        return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }}
                                    showSearch
                                    placeholder="Selecione um município"
                                    >
                                    {loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "") ? 
                                    <>
                                    <Select.Option  value={municipios?.municipioID}>{municipios?.nome}</Select.Option>
                                    </>                                    
                                    :
                                    <>
                                    {municipios?.map((value:any, index:number)=>
                                        <Select.Option key={index} value={value.municipioID}>{value.nome}</Select.Option>
                                        )}
                                    </>
                                    }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label="Mês"
                                    name="mes"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira um mês!',
                                        }
                                    ]}
                                    initialValue={0}
                                >
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione um mes"
                                    >
                                        {meses.map((m, index) => <Select.Option key={index} value={m.id}>{m.descricao}</Select.Option>)}

                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label="Ano"
                                    name="ano"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma data!',
                                        }
                                    ]}
                                    initialValue={anoAtual}
                                >
                                    <Input placeholder="informe o ano" />
                                </Form.Item>
                                <Spin spinning={loading}>
                                    <Button className="button-filtrar button-nacionalidade-mes-ano" type="primary" htmlType="submit">
                                        Emitir Relatório
                                    </Button>
                                </Spin>
                            </Col>
                        </Row>
                    </Form>
                </fieldset>
                {/* <br />
                <fieldset className="fieldset-consulta borda-fieldset-servicos">
                    <legend className="custom-legend">Quantitativo de Serviços ofertados</legend>
                    <Form
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                        layout="horizontal"
                        size="middle"
                        onFinish={RelatorioServicoOfertado}
                        form={formServicoOfertado} >
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="Mês"
                                    name="mes"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira um mês!',
                                        }
                                    ]}
                                    initialValue={0}
                                >
                                    <Select placeholder="selecione">
                                        {meses.map((m, index) => <Select.Option key={index} value={m.id}>{m.descricao}</Select.Option>)}

                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="Ano"
                                    name="ano"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira um ano!',
                                        }
                                    ]}
                                    initialValue={anoAtual}
                                >
                                    <Input placeholder="informe o ano" />
                                </Form.Item>
                                <Spin spinning={loading}>
                                    <Button className="button-filtrar button-serivos-ofertados" type="primary" htmlType="submit">
                                        Emitir Relatório
                                    </Button>
                                </Spin>
                            </Col>
                        </Row>
                    </Form>
                </fieldset> */}
                <br />
                <fieldset className="fieldset-consulta borda-fieldset-servicos-orgaos">
                    <legend className="custom-legend">Quantitativo de Serviços ofertados por Órgão</legend>
                    <Form
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                        layout="horizontal"
                        size="middle"
                        onFinish={RelatorioServicoOfertadoOrgao}
                        form={formServicoOfertadoOrgao} >
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="Órgão"
                                    name="orgao"
                                    initialValue={null}
                                >
                                    <Select
                                        onSelect={(e: any) => { getVinculoOrgaoServico(e); }}
                                        placeholder="Selecione um órgão"
                                    >
                                        <Select.Option value="null">
                                            Selecione
                                        </Select.Option>
                                        {orgaos.map((option, index) => {
                                            return option?.ativo ?
                                                <Select.Option key={index} value={option.orgaoID}>
                                                    {option.nome} - ({option.sigla})
                                                </Select.Option>
                                                : null;
                                        })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="Serviço"
                                    name="servico"
                                >
                                    {
                                        selecionouOrgao ? <Select
                                            notFoundContent={<Empty description="Selecione um órgao com serviço ativo!" />}
                                            placeholder="Selecione um serviço!"
                                        >
                                            {vinculos?.map((option, index) => {
                                                return option.servico?.ativo ? <Select.Option key={index} value={option.vinculoOrgaoServicoID}>
                                                    {option.servico.descricao}
                                                </Select.Option> : null;
                                            })
                                            }
                                        </Select>
                                            :
                                            <Select
                                                placeholder="Selecione um Serviço"
                                            >
                                                {servicos.map((option, index) => {
                                                    return option?.ativo ?
                                                        <Select.Option key={index} value={option.servicoID}>
                                                            {option.descricao}
                                                        </Select.Option>
                                                        : null;
                                                })}
                                            </Select>
                                    }

                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="Mês"
                                    name="mes"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira um mês!',
                                        }
                                    ]}
                                    initialValue={0}
                                >
                                    <Select placeholder="selecione">
                                        {meses.map((m, index) => <Select.Option key={index} value={m.id}>{m.descricao}</Select.Option>)}

                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="Ano"
                                    name="ano"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira um ano!',
                                        }
                                    ]}
                                    initialValue={anoAtual}
                                >
                                    <Input placeholder="informe o ano" />
                                </Form.Item>
                                <Spin spinning={loading}>
                                    <Button className="button-filtrar button-serivos-ofertados-orgaos" type="primary" htmlType="submit">
                                        Emitir Relatório
                                    </Button>
                                </Spin>
                            </Col>
                        </Row>
                    </Form>
                </fieldset>
                <br />
                <fieldset className="fieldset-consulta borda-fieldset-nacionalidade">
                    <legend className="custom-legend">Quantitativo de Migrantes atendidos por Nacionalidade, Cidade, Mês e Ano</legend>
                    <Form
                        form={formMigrantesNacionalidadeMes}
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                        layout="horizontal"
                        onFinish={RelatorioMigranteNacionalidade}
                        size="middle" >
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col className="gutter-row" span={8}>
                                <Form.Item name="nacionalidade" label="Nacionalidade" initialValue="">
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione um país de Nacionalidade"
                                    >
                                        <Select.Option value="">Todas</Select.Option>
                                        {paises.map((p, index) => <Select.Option key={index} value={p}>{p}</Select.Option>)}

                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={8}>
                                <Form.Item
                                    label="Municipio"
                                    name="RelatorioMigranteCidade"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma cidade!',
                                        }
                                    ]}
                                >
                                    <Select filterOption={(input: any, option: any) => {
                                        return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }}
                                    showSearch
                                    placeholder="Selecione um município"
                                    >
                                    {loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "") ? 
                                    <>
                                    <Select.Option  value={municipios?.municipioID}>{municipios?.nome}</Select.Option>
                                    </>                                    
                                    :
                                    <>
                                    {municipios?.map((value:any, index:number)=>
                                        <Select.Option key={index} value={value.municipioID}>{value.nome}</Select.Option>
                                        )}
                                    </>
                                    }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label="Mês"
                                    name="mes"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira um mês!',
                                        }
                                    ]}
                                    initialValue={0}
                                >
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione um mes"
                                    >
                                        {meses.map((m, index) => <Select.Option key={index} value={m.id}>{m.descricao}</Select.Option>)}

                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={4}>
                                <Form.Item
                                    label="Ano"
                                    name="ano"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor insira uma data!',
                                        }
                                    ]}
                                    initialValue={anoAtual}
                                >
                                    <Input placeholder="informe o ano" />
                                </Form.Item>
                                <Spin spinning={loading}>
                                    <Button className="button-filtrar button-nacionalidade-mes-ano" type="primary" htmlType="submit">
                                        Emitir Relatório
                                    </Button>
                                </Spin>
                            </Col>
                        </Row>
                    </Form>
                </fieldset>


            </div>
            <Footer></Footer>
        </div>

    );
}

export default Relatorio